import React, { useState, useEffect } from 'react'
import SearchIconAsset from '../../../assets/Content-Icons/Svgs/search-icon-asset.svg'
import FilterIcon from '../../../assets/Content-Icons/Svgs/filter-icon.svg'
import RemoveIcon from '../../../assets/Content-Icons/Svgs/remove-icon.svg'
import CheckedIcon from '../../../assets/Content-Icons/Svgs/checkbox-checked-icon.svg'
import UncheckedIcon from '../../../assets/Content-Icons/Svgs/checkbox-unchecked-icon.svg'
import TickIcon from '../../../assets/filter-tick-icon.svg'
import { CButton } from '@coreui/react'
import { isEmpty } from 'lodash'

const btnStyles = {
  width: '88px',
  height: '30px',
  borderRadius: '4px',
  border: '0.8px solid #707070',
  fontSize: '12px',
}

const AssetFilter = ({
  filters = [],
  onSearch,
  onClearAll,
  onApply,
  dropdownHeight = '300px',
  dropdownTopValue = '3.25vh',
  disableFilter = false,
  searchStyle = { background: 'none' },
}) => {
  const [filterDropdown, setFilterDropdown] = useState(false) // for filter dropdown
  const [searchText, setSearchText] = useState('')
  const [filtersLocal, setFiltersLocal] = useState([])
  const [isFilterApplied, setIsFilterApplied] = useState(false)

  useEffect(() => {
    if (!disableFilter) {
      setFiltersLocal(filters)
      checkFilterApplied()
    }
  }, [filters])

  const checkFilterApplied = () => {
    for (let index = 0; index < filters.length; index++) {
      const filterObj = filters[index]
      const isSelected = filterObj.checkedState.length > 0

      if (isSelected) {
        setIsFilterApplied(true)
        break
      }
      if (!isSelected && index === filters.length - 1) {
        setIsFilterApplied(false)
      }
    }
  }

  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase()

    if (event.key === 'Enter') {
      onSearch(value)
    }
  }
  return (
    <div style={{ marginRight: 'auto', zIndex: '20' }}>
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ outline: '2px solid transparent', gap: '1.6vw' }}
      >
        <div
          style={{
            border: '.5px solid #707070',
            borderRadius: '15px',
            width: '20vw',
            height: '30px',
            padding: '6px 12px',
            ...searchStyle,
          }}
          className="d-flex align-items-center justify-content-between"
        >
          <input
            type="text"
            placeholder="Search"
            style={{
              ...searchStyle,
              padding: '0 4px',
              outline: 'none',
              border: 'none',
              height: '100%',
              width: '90%',
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyPress={(e) => handleSearch(e)}
          />
          <img
            src={SearchIconAsset}
            alt="SearchIconAsset"
            onClick={() => onSearch(searchText.toLowerCase())}
          />
        </div>
        {!disableFilter && (
          <button
            style={{
              border: '.5px solid #707070',
              borderRadius: '15px',
              width: 'max(6vw,105px)',
              height: '30px',
              padding: '5px 23px',
              background: isFilterApplied ? '#fff' : '#d1d1d1',
            }}
            className="d-flex align-items-center justify-content-between position-relative"
            onClick={() => setFilterDropdown(!filterDropdown)}
          >
            <img src={FilterIcon} alt="FilterIcon" />
            <span style={{ fontSize: '14px' }}>Filters</span>
            {isFilterApplied && (
              <img
                style={{ right: '-0.4rem' }}
                src={TickIcon}
                alt="TickIcon"
                className="position-absolute"
              />
            )}
          </button>
        )}
      </div>
      <div
        className={`filter-dropdown ${filterDropdown === true ? 'active' : ''}`}
        style={{
          height: dropdownHeight,
          top: `${filterDropdown === true ? `calc(100% + ${dropdownTopValue})` : ''} `,
        }}
      >
        {/* filter options */}
        <div
          className="px-5"
          style={{
            height: '83%',
          }}
        >
          <div
            className="d-flex justify-content-start custom-scrollbar-horizontal pb-4"
            style={{
              outline: '2px solid transparent',
              gap: '0 2vw',
              height: '100%',
              overflowX: 'auto',
              overflowY: 'visible',
            }}
          >
            {!isEmpty(filtersLocal) &&
              filtersLocal.map((filterObj) => {
                return filterObj.type === 'radio' ? (
                  <div
                    className="d-flex flex-column"
                    style={{ width: '12%', flexShrink: '0' }}
                    key={filterObj.title}
                  >
                    <p
                      style={{
                        borderBottom: '1px solid #707070',
                        fontWeight: '600',
                        paddingBottom: '5px',
                        marginBlockEnd: '.75rem',
                      }}
                    >
                      {filterObj.title}
                    </p>
                    <div
                      className="d-flex flex-column custom-scrollbar-vertical"
                      style={{ gap: '8px 0', height: '100%', overflowY: 'auto' }}
                    >
                      {filterObj.options.map((info, idx) => {
                        return (
                          <span key={idx}>
                            <input
                              id={info.value}
                              type="radio"
                              className="filter-asset-manager-cformcheck"
                              value={info.value}
                              checked={filterObj.checkedState === info.value}
                              onChange={(e) => {
                                filterObj.onSelect(e.target.value)
                              }}
                            />
                            <label htmlFor={info.value} className="cursor-pointer">
                              {info.name}
                            </label>
                            {filterObj.checkedState === info.value && (
                              <img
                                src={RemoveIcon}
                                alt=""
                                className="ml-2 cursor-pointer"
                                onClick={() => filterObj.onSelect('')}
                              />
                            )}
                          </span>
                        )
                      })}
                    </div>
                  </div>
                ) : (
                  <div
                    className="d-flex flex-column"
                    style={{ width: '12%', flexShrink: '0' }}
                    key={filterObj.title}
                  >
                    <p
                      style={{
                        borderBottom: '1px solid #707070',
                        fontWeight: '600',
                        paddingBottom: '5px',
                        marginBlockEnd: '.75rem',
                      }}
                    >
                      {filterObj.title}
                    </p>
                    <div
                      className="d-flex flex-column custom-scrollbar-vertical"
                      style={{ gap: '8px 0', height: '100%', overflowY: 'auto' }}
                    >
                      {filterObj.options.map((info, idx) => {
                        return (
                          <span key={idx}>
                            <input
                              id={info.value}
                              value={info.value}
                              checked={filterObj.checkedState.includes(info.value)}
                              onChange={(e) => {
                                filterObj.onSelect(e.target.checked, e.target.value)
                              }}
                              type="checkbox"
                              name={info.name}
                              className="filter-asset-manager-checkbox"
                            />
                            <label htmlFor={info.value} className="cursor-pointer">
                              <img src={CheckedIcon} alt="" className="checked-icon mr-2" />
                              <img src={UncheckedIcon} alt="" className="unchecked-icon mr-2" />
                              {info.name}
                            </label>
                          </span>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
        {/* clear and apply buttons */}
        <div className="d-flex justify-content-end px-4" style={{ gap: '0 30px' }}>
          <CButton
            className=""
            style={{
              color: '#3a3838',
              backgroundColor: 'white',
              padding: '4px 17px',
              ...btnStyles,
            }}
            onClick={() => {
              onClearAll()
              setFilterDropdown(false)
            }}
          >
            Clear All
          </CButton>
          <CButton
            className=""
            style={{
              color: 'white',
              backgroundColor: '#20211c',
              padding: '4px 20px',
              ...btnStyles,
            }}
            onClick={() => {
              onApply()
              setFilterDropdown(false)
            }}
          >
            Apply
          </CButton>
        </div>
      </div>
    </div>
  )
}

export default AssetFilter

/*
  .filter-dropdwon - this class is used to show/hide the filter-dropdown
                    search for the ".filter-dropdown" globally, filter-dropdown class properties is written in css files
                    also it is relative to the parent component(with width 97.5%) in the modal component
  .filter-asset-manager-checkbox - this class is responsible for all the checkboxes styling
*/
